import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'

export async function deleteFragment (uploadType2Id, fragmentId) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  const collectionReference = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('UploadType2s')
    .doc(uploadType2Id).collection('Fragments')

  try {
    savingStart()
    await collectionReference.doc(fragmentId).delete()
    savingEnd()
  } catch (e) {
    handleErrorInCatch(e, 'deleteFragment.js')
  }
}
